/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    emailVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    preferredUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    picture?: string;
}

/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value: object): value is UserInfo {
    return true;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'sub': json['sub'] == null ? undefined : json['sub'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailVerified': json['email_verified'] == null ? undefined : json['email_verified'],
        'name': json['name'] == null ? undefined : json['name'],
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'preferredUsername': json['preferred_username'] == null ? undefined : json['preferred_username'],
        'picture': json['picture'] == null ? undefined : json['picture'],
    };
}

export function UserInfoToJSON(json: any): UserInfo {
    return UserInfoToJSONTyped(json, false);
}

export function UserInfoToJSONTyped(value?: UserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sub': value['sub'],
        'email': value['email'],
        'email_verified': value['emailVerified'],
        'name': value['name'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'preferred_username': value['preferredUsername'],
        'picture': value['picture'],
    };
}

